import React from "react";
import { useLocation } from "react-router-dom";
import Faq from "../faq/Faq";
import Utilization from "../utilization/Utilization";
import TagSection from "../tagSection/TagSection";
import Message from "../message/Message";
import StartWith from "../startwith/StartWith";
import TagSolu from "../tagSolutionItems/TagSolu";
import Banner from "../banner/Banner";
import GetInTouch from "../getintouch/GetInTouch";
import Sliderr from "../slider/Sliderr";
import Team from "../team/Team";
import Hero from "../hero/Hero";
import Footer from "../footer/Footer";
import Hero1 from "../hero/Hero1";
import StickyNavHeader from "../header/StickyNavHeader";
import BackToTop from "../common/BackToTop";
import { useParams, useSearchParams } from "react-router-dom";

const Landing = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (location.state?.scrollTo) {
      // Use a longer timeout to ensure all components are rendered
      const timer = setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <div className="font-lexend-deca ">
      <StickyNavHeader />
      <Hero1 />
      {/* <Hero /> */}
      <TagSection />
      <TagSolu />
      <div id="faq-section" className="scroll-mt-32">
        <Utilization />
      </div>
      <StartWith />
      <Message />
      {/* <Faq /> */}
      <div id="app-section" className="scroll-mt-32">
        <Banner />
      </div>

      {/* <Team /> */}

      <div id="contact-section" className="scroll-mt-32">
        <GetInTouch />
      </div>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Landing;
